import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Modal from 'react-native-modal';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import {isIphoneX} from 'react-native-iphone-screen-helper';

export const Container = styled(Modal)`
  justify-content: flex-end;
  margin: 0;
`;

export const ModalHeader = styled.View`
  margin: ${RFValue(16)}px 0;
  justify-content: center;
  align-items: center;
`;
export const Title = styled.Text`
  text-align: center;
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
`;

export const ModalContent = styled.View`
  background-color: ${({theme}) => theme.colors.background};

  height: ${isIphoneX() ? RFPercentage(25) : RFPercentage(24)}px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow: hidden;
  padding: 0 24px;
`;

export const ModalBody = styled.View`
  flex: 1;
  padding: 0 24px;
  justify-content: center;
  align-items: center;
  margin-bottom: ${isIphoneX() ? RFValue(18) : RFValue(16)}px;
`;

export const ItensList = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
`;

export const Item = styled.View`
  align-items: center;
  width: ${RFValue(80)}px;
  justify-content: center;
`;

export const ItemCard = styled.TouchableOpacity`
  align-items: center;
  justify-content: center;
`;
export const ItemIconContainer = styled.View`
  align-items: center;
  justify-content: center;
  width: ${RFValue(48)}px;
  height: ${RFValue(48)}px;

  background-color: ${({theme}) => theme.colors.title};
  border-radius: ${RFValue(40)}px;

  margin-bottom: ${RFValue(5)}px;
`;
export const ItemIcon = styled(FontAwesome)`
  font-size: ${RFValue(16)}PX;
  color: ${({theme}) => theme.colors.buttonTitle};
`;
export const ItemName = styled.Text`
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.title};
  text-align: center;
`;
